// extracted by mini-css-extract-plugin
export default {"toIntakeButton":"analysis_toIntakeButton__00LQD","label":"analysis_label__RN6Te"};